/**
 * Border radius tokens from the Figma "Primitives" collection.
 * Source of truth: Pangea Galapagos UI Design System — Beta
 * https://www.figma.com/design/Orc6uUodQaoXep59CGaUNw
 */

export const radius = {
  s: 2,
  sm: 4,
  m: 8,
  lg: 12,
  xl: 16,
  xxl: 24,
  xxxl: 32,
  rounded: 100,
} as const;

export type Radius = typeof radius;
